module.exports = __webpack_public_path__ + "img/more-icon.99bd6b32.svg";